export const ALIGNMENT_THRESHOLD = 1.75;
